import { render, staticRenderFns } from "./FacilityCodeRegistration.vue?vue&type=template&id=1072a868&scoped=true&"
import script from "./FacilityCodeRegistration.vue?vue&type=script&lang=js&"
export * from "./FacilityCodeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FacilityCodeRegistration.vue?vue&type=style&index=0&id=1072a868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072a868",
  null
  
)

export default component.exports